export enum DuplicateStrategyWizardActionType {
  OpenWizard = 'OpenWizard',
  CloseWizard = 'CloseWizard',
}
